import { Component, Input } from "@angular/core"
import { ActivatedRoute, Router } from "@angular/router"
import { LearningObject } from "../../../models/learningObject.model"
import { SearchInfoModel } from "../../../models/searchInfo.model"
import { BrowsingService } from "../../../services/browsing.service"
import { GTMService } from "../../../services/gtm.service"
import { SearchingService } from "../../../services/searching.service"
import { SearchResultsGroupComponent } from "../../../shared-components/search/search-results-group/search-results-group.component"
import { AddOnViewService } from "../../../services/add-on-view.service"

@Component({
    selector: "app-collection-search-result-group",
    templateUrl: "collection-search-result-group.component.html",
    styleUrls: ["collection-search-result-group.component.scss"],
    standalone: false,
})
export class CollectionSearchResultGroupComponent extends SearchResultsGroupComponent {
    @Input() public collectionSlug: string
    @Input() public searchInfo: SearchInfoModel

    constructor(
        public browsingService: BrowsingService,
        public searchingService: SearchingService,
        public route: ActivatedRoute,
        public router: Router,
        public gtmService: GTMService,
        public addOnViewService: AddOnViewService
    ) {
        super(browsingService, searchingService, route, router, gtmService, addOnViewService)
    }

    public onDidYouMeanClick() {
        const queryParams = { q: this.didYouMeanSuggestions.text }
        this.router.navigate(["/collection", this.collectionSlug, "search"], {
            queryParams,
            queryParamsHandling: "merge",
        })
    }

    public getSearchResults(queryParams) {
        this.customSubscriptions.map((subscription) => subscription.unsubscribe())
        this.learningObjectResults = []
        this.searchingService.resultsAreLoading.next(true)
        this.customSubscriptions.push(
            this.searchingService
                .getCollectionSearchResults(queryParams, this.collectionSlug)
                .subscribe(
                    (data: any) => {
                        this.learningObjectResults = data.objects.map(
                            (obj) => new LearningObject(obj)
                        )
                        this.nextUri = data.meta.next_uri
                        this.firstNextUri = data.meta.next_uri
                        this.resultsCount = data.meta.total
                        if (this.resultsCount > 10000) {
                            this.totalResultsForPagination = 10000 - this.resultsPerPage
                        } else {
                            this.totalResultsForPagination = this.resultsCount
                        }
                        this.searchingService.availableFacetsChanged.next(data.meta.facets.fields)
                        this.didYouMeanSuggestions = data.meta.suggestions
                        this.searchingService.resultsAreLoading.next(false)
                    },
                    (error) => console.error(`[CUSTOM Error]${error.message}`)
                )
        )
    }
}
